import request from '../utils/request';
import { CreateEventPayload, UserRating } from '../utils/types';

export const fetchEventDetails = async (eventId: string) => {
    const details = await request.get(`/sport-events/${eventId}`);
    return details.data;
};

export const fetchEvents = async (
    city: string,
    skip: number,
    take: number,
    type?: string
) => {
    const details = await request.get(
        `/sport-events?city=${city}${
            type ? `&type=${type}` : ''
        }&skip=${skip}&take=${take}`
    );
    return details.data;
};

export const fetchFinderEvents = async (
    country: string,
    city: string,
    skip?: number,
    take?: number,
    type?: string
) => {
    const events = await request.get(
        `/sport-events?country=${country}&city=${city}${
            type ? `&type=${type}` : ''
        }&skip=${skip}&take=${take}`
    );
    return events.data;
};

export const fetchUserEvents = async () => {
    const response = await request.get('/sport-events/my-events');
    return response.data;
};

export const fetchNextEvents = async () => {
    const record = await request.get(`/sport-events/get-next`);
    return record.data;
};

export const joinEventAPI = async (eventId: string, teamName: string) => {
    const record = await request.patch(
        `/sport-events/${eventId}/join/${teamName}`
    );
    return record.data;
};

export const leaveEventAPI = async (eventId: string) => {
    const record = await request.patch(`/sport-events/${eventId}/leave`);
    return record.data;
};

export const changeTeamAPI = async (eventId: string, userId: string) => {
    const record = await request.patch(
        `/sport-events/${eventId}/${userId}/change-team`
    );
    return record.data;
};

export const requestJoinAPI = async (eventId: string) => {
    const record = await request.post(`/sport-events/${eventId}/join-requests`);
    return record.data;
};

export const acceptJoinRequestAPI = async (
    eventId: string,
    joinRequestId: string
) => {
    const record = await request.patch(
        `/sport-events/${eventId}/join-requests/${joinRequestId}`
    );
    return record.data;
};

export const rejectJoinRequestAPI = async (
    eventId: string,
    joinRequestId: string
) => {
    const record = await request.delete(
        `/sport-events/${eventId}/join-requests/${joinRequestId}`
    );
    return record.data;
};

export const createEventAPI = async (eventPayload: CreateEventPayload) => {
    const record = await request.post(`/sport-events`, eventPayload);
    return record.data;
};

export const updateEventAPI = async (
    eventId: string,
    eventPayload: CreateEventPayload
) => {
    const record = await request.put(`/sport-events/${eventId}`, eventPayload);

    return record.data;
};

export const cancelEventAPI = async (eventId: string) => {
    const record = await request.patch(`/sport-events/${eventId}/cancel`);

    return record.data;
};

export const startVotingPhaseAPI = async (eventId: string) => {
    const record = await request.patch(`/sport-events/${eventId}/voting`);

    return record.data;
};

export const voteEventAPI = async (
    eventId: string,
    ratings: UserRating[],
    winner: string | null
) => {
    const record = await request.patch(`/sport-events/${eventId}/vote`, {
        ratings,
        winner,
    });
    return record.data;
};

export const writeBoardMessageAPI = async (
    eventId: string,
    message: string
) => {
    const record = await request.patch(`/sport-events/${eventId}/board`, {
        eventId,
        message,
    });
    return record.data;
};
